import React from 'react'
import ErrorBoundary from './ErrorBoundary'

export const withErrorBoundary = boundary => Component => props =>
  (
    <ErrorBoundary boundary={boundary}>
      <Component {...props} />
    </ErrorBoundary>
  ) // eslint-disable-line react/display-name
